export default "__VITE_ASSET__DqZo5yoJ__"